import React from 'react';
import AbstractRequestTask from '../AbstractRequestTask';
import { GetRegion } from '../../../constants';

class PurchaseButtonTask extends AbstractRequestTask {
  constructor(config, params) {
    super();
    this.config = config;
    this.params = params;
  }

  getUrl() {
    const domain = this.config.url_dominio_microfwk;

    return `${domain}services/payway/purchasebuttoninfo`;
  }

  getParams() {
    const params = super.getParams(this.config);

    // if ( GetRegion() == 'brasil' ) {
    //  params.api_version = 'v4.7';
    // }

    this.params = Object.assign(params, this.params);
    return params;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    let brasil = true;

    if (typeof data.errors !== 'undefined') {
      if (data.errors.code == 'net_rent_disabled') {
        data.response.errors = super.parseErrors(data);
        brasil = false;
      }
    }

    if (!isValid && brasil) {
      const newError = super.parseErrors(data);
      return this.reject(newError, b);
    }

    let maxPurchasedPrice = 0;
    if (data.response.listButtons) {
      data.response.listButtons.button = data.response.listButtons.button
        // Remove for susc button for free contents
        .filter(button => !(button.oneoffertype == 'subscrition' && button.waspurchased == '1'))
        // Add auxiliar properties and create maxPurchasedPrice when the content was purchased
        .map((button) => {
          button.waspurchased = button.waspurchased == '1';

          button.withDownload = false;

          if (button.oneoffertype) {
            button.withDownload = button.oneoffertype.includes('download');
          }
          if (button.price) {
            button.priceNumber = parseInt(button.price);
            if (button.waspurchased && maxPurchasedPrice < button.priceNumber) {
              maxPurchasedPrice = button.priceNumber;
            }
          }
          return button;
        });
    }
      // remove buttons with less price than the purchased

    this.resolve(data.response);
  }
}

export default PurchaseButtonTask;
